import { symmetricDifference, isEmpty } from 'ramda';

/**
 * Utility functions for worklist views.
 *
 * @module worklistUtils
 */

const DELIMITER = ',';

const hasSameItems = <T>(arr1: ReadonlyArray<T>, arr2: ReadonlyArray<T>): boolean =>
  arr1.length === arr2.length && isEmpty(symmetricDifference(arr1, arr2));

const joinSmidsToString = (smids: ReadonlyArray<string | null>): string => {
  return smids ? [...smids].sort().join(DELIMITER) : '';
};

const splitStringToSmids = (smidsString: string): string[] => smidsString.split(DELIMITER);

export { hasSameItems, joinSmidsToString, splitStringToSmids };
